module.exports = __webpack_public_path__ + "static/img/sfz_btn2.11402fbd.png";